import { PaymentInstrument } from 'types/api/intent';
import { AddPaymentInstrumentRequestBody } from 'types/api/payment-instrument';
import { FetchResponse } from 'types/fetch';
import endpoints from '../endpoints';
import fetchReq from '../fetch';

type AddPIOptions = {
  accessToken: string;
  apikey: string;
  requestPayload: AddPaymentInstrumentRequestBody;
};

export function fetchAddPaymentInstrument({
  accessToken,
  apikey,
  requestPayload
}: AddPIOptions): FetchResponse<{ paymentInstrument: PaymentInstrument }> {
  return fetchReq({
    body: requestPayload,
    headers: {
      access_token: accessToken
    },
    mark: 'post_payment_instrument',
    method: 'POST',
    url: `${endpoints.addPaymentInstrument}?apikey=${apikey}`
  });
}
